
<app-india-map [mapData]="mapData" [statesData]="mapStateData" [districtsData]="mapDistrictData" (districtApiTrigger)="getDistrictData($event)" ></app-india-map>
